export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const CHECK_USER_SESSION = 'CHECK_USER_SESSION';
export const EMAIL_SIGN_IN_START = 'EMAIL_SIGN_IN_START';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const SIGN_OUT_START = 'SIGN_OUT_START';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'SIGN_OUT_FAILURE';

/*export const SIGN_UP_START = 'SIGN_UP_START';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';*/

// Data types
export interface IUser {
    id:string;
    displayName:string;
    email:string;
    image?:string;
}


// State type
export interface IUserState {
    currentUser?: (IUser | null);
    error?:(string | null);
}


// Action types
export interface ISignInSuccess {
    type: typeof SIGN_IN_SUCCESS;
    payload: IUser;
};

interface ISignInFailure {
    type: typeof SIGN_IN_FAILURE;
    payload: string;
};

interface IEmailSignInStartPayload {
    email:string;
    password:string;
}
interface IEmailSignInStart {
    type: typeof EMAIL_SIGN_IN_START;
    payload: IEmailSignInStartPayload;
};
export type TypeEmailSignInStartPayload = IEmailSignInStartPayload;
export type TypeEmailSignInStartAction = IEmailSignInStart;

interface ICheckUserSession {
    type: typeof CHECK_USER_SESSION;
};

interface ISignOutStart {
    type: typeof SIGN_OUT_START;
};

interface ISignOutSuccess {
    type: typeof SIGN_OUT_SUCCESS;
};

interface ISignOutFailure {
    type: typeof SIGN_OUT_FAILURE;
    payload: string;
};

export type TypeUserAction = ISignInSuccess  | ISignInFailure  | IEmailSignInStart | ICheckUserSession | 
ISignOutStart | ISignOutSuccess | ISignOutFailure;